/* eslint-disable require-jsdoc */
import api from '@/api/index.js';
import Vue from 'vue';
import router from '../router';
import store from '@/store';
import menuData from '../utils/menu.js';
const _this = new Vue();
let menu = ''
let menuFatherId = ''
async function checkMeta(to, next) {}

async function checkMetaAfter(to) {}
// 递归处理选中数据
async function filterList(path, list) {
  // 结束条件
  if (list && list.length > 0) {
    // 循环遍历
    for (let i = 0; i < list.length; i++) {
      //结束递归
      if (list[i].path === path) {
        menu = list[i]
        return;
      } else {
        // 如果数组中有children则继续递归
        if (list[i].children) {
          filterList(path, list[i].children);
        } else {}
      }
    }
  }
}
export default {
  install() {
    router.beforeEach(async (to, from, next) => {
      /* 路由发生变化 */
      filterList(to.path, menuData)
      if (menu) {
        sessionStorage.setItem('menuActived', JSON.stringify(menu));
      }
      let utoken = _this.getCookie('utoken')
      if (to.meta.isLogin && utoken == '') {
        document.body.scrollTop = 0; // firefox
        document.documentElement.scrollTop = 0; // safari
        window.pageYOffset = 0; //
        store.commit('setUserInfo', {});
        sessionStorage.clear()
        next('/login');
        store.commit('setSearch', {
          filterParam: ''
        });
      } else {
        if (sessionStorage.getItem('dictionary') == '' || store.state.dictionary == '' && _this.getCookie('utoken')) {
          // 字典接口用于存值
          api.getDictDataByType(['dl_channel', 'series_content_types', 'asp_series_info_affiliates', 'asp_series_info_manufacturer']).then(res => {
            if (res.code == 200) {
              if (res.data) {
                res.data.asp_series_info_affiliates.unshift({
                  dictLabel: "全部",
                  dictType: "asp_series_info_affiliates",
                  dictValue: "",
                  flag: true
                })
                res.data.asp_series_info_affiliates.push({
                  dictLabel: "其他",
                  dictType: "asp_series_info_affiliates",
                  dictValue: "其他",
                  flag: false
                })
                res.data.asp_series_info_manufacturer.unshift({
                  dictLabel: "全部",
                  dictType: "asp_series_info_manufacturer",
                  dictValue: "",
                  flag: true
                })
                res.data.asp_series_info_manufacturer.push({
                  dictLabel: "其他",
                  dictType: "asp_series_info_manufacturer",
                  dictValue: "其他",
                  flag: false
                })
                res.data.dl_channel.unshift({
                  dictLabel: "全部",
                  dictType: "dl_channel",
                  dictValue: "",
                  flag: true
                })
                res.data.series_content_types.unshift({
                  dictLabel: "全部",
                  dictType: "series_content_types",
                  dictValue: "",
                  flag: true
                })
                res.data.series_content_types.push({
                  dictLabel: "其他",
                  dictType: "series_content_types",
                  dictValue: "其他",
                  flag: false
                })
                // 存储字符串到sessionStorage
                sessionStorage.setItem('dictionary', JSON.stringify(res.data));
                store.commit('dictionary', res.data || {});
              }
            } else {}
          }).catch(rej => {})
        }

        let type = null
        // 1是会员0不是会员
        let obj = JSON.parse(sessionStorage.getItem('userInfo'));
        console.log('路由获取用户是否会员obj.statusMsg', obj);
        if (obj && obj.pcVipStatus == 1) {
          type = 1
        } else {
          type = 2
        }
        if (type) {
          if (type == '1' || !to.meta.isLogin) {
            next()
          } else {
            if (to.name == 'login') {
              next()
            } else {
              if ((to.name != 'index')) {
                console.log('to.name', to.name);
                if (to.name == 'login') {
                  next()
                } else {
                  if(to.name === 'userinfo'){
                    next()
                  }else{
                    next('/index')
                  }
                  
                }
              } else {
                next()
              }
            }
          }
        }
        // next()
        // 打开页面回到页面回到顶部 返回不回到顶部
        if (to.meta.zIndex < from.meta.zIndex) {
          // 返回
        } else {
          // 打开
          document.body.scrollTop = 0; // firefox
          document.documentElement.scrollTop = 0; // safari
          window.pageYOffset = 0; //
        }
        store.commit('setSearch', {
          filterParam: ''
        });
      }
    });

    router.afterEach(async (to, from) => {

    });

    router.onError((err) => {
      console.log(err);
      if (err && err != '{}') {
        window.location.reload(true);
      }
    });
  },
};



// WEBPACK FOOTER //
// ./src/config/routerIntercept.js